import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, memo } from 'react';
import { styled, useDeprecatedCheck, useThemeProps, } from '../../foundation';
import { TagStyle } from './styles';
var _RcTag = memo(forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTag' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcTag, props, [
            {
                prop: 'content',
                comment: 'you should replace with children',
                time: '2021-1',
            },
        ]);
    }
    var color = props.color, children = props.children, content = props.content, textColor = props.textColor, borderColor = props.borderColor, radius = props.radius, rest = __rest(props, ["color", "children", "content", "textColor", "borderColor", "radius"]);
    return (React.createElement("span", __assign({}, rest, { ref: ref }), content || children));
}));
var RcTag = styled(_RcTag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TagStyle);
RcTag.defaultProps = {
    color: 'highlight.b03',
    textColor: 'neutral.f01',
    radius: 'xl',
};
RcTag.displayName = 'RcTag';
export { RcTag };
var templateObject_1;
